var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import * as Styled from './Breadcrumbs.styled';
import { ContainerQueryContext } from '../../../../util/ContainerQuery.context';
import { track } from '../../../../util/optimizely';
import LinkText from '../../../LinkText/LinkText';
import Icon from '../../../Icons/Icon';
var Breadcrumbs = function (_a) {
    var _b = _a.crumbs, crumbs = _b === void 0 ? [] : _b, _c = _a.dataLabel, dataLabel = _c === void 0 ? 'breadcrumbs' : _c, props = __rest(_a, ["crumbs", "dataLabel"]);
    if (!(crumbs === null || crumbs === void 0 ? void 0 : crumbs.length))
        return null;
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    var handleClick = function () {
        track('Clicks_On_PDP_Breadcrumbs_Link');
    };
    return (React.createElement(Styled.Breadcrumbs, __assign({ "data-label": dataLabel }, props), crumbs.map(function (crumb) { return (React.createElement(Styled.Crumb, { key: crumb.name, "$styleQueryMode": styleQueryMode },
        React.createElement(LinkText, { iconPosition: 'left', href: crumb.link, onClick: function () { return handleClick(); }, icon: crumbs.length === 1 ? React.createElement(Icon, { "data-name": "icon-right", name: "arrow-left" }) : null }, crumb.name))); })));
};
export default Breadcrumbs;
